export default {
  title: 'Importe mínimo de pago: Los pagos no pueden estar entre {{rangeStart}} - {{rangeEnd}}',
  description: 'Excepción: Si tienes un artículo gratuito, puedes finalizar la compra con un total de {{amount}}.',
};
